import { useEffect, useState } from "react";
import { NavLink } from "react-router";
import { api } from "../lib/api.ts";
import { useT } from "../lib/i18n.tsx";
import { useMe } from "../lib/me.tsx";

/** Header bell with unread count; polls every 60 s and on focus (R-NTF-1). */
export function Bell() {
  const t = useT();
  const { me } = useMe();
  const [unread, setUnread] = useState<number>(me?.unread_notifications ?? 0);

  useEffect(() => {
    if (!me) return;
    let live = true;
    const load = () =>
      api<{ unread: number }>("/api/me/notifications?limit=0")
        .then((r) => live && setUnread(r.unread))
        .catch(() => undefined);
    const id = setInterval(load, 60_000);
    const onFocus = () => void load();
    window.addEventListener("focus", onFocus);
    return () => {
      live = false;
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
    };
  }, [me]);

  if (!me) return null;
  return (
    <NavLink
      to="/me/notifications"
      className="iconbtn bell"
      aria-label={t("nav.notifications")}
      data-testid="bell"
    >
      <span aria-hidden="true">🔔</span>
      {unread > 0 ? (
        <span className="bell__count" data-testid="bell-count">
          {unread > 99 ? "99+" : unread}
        </span>
      ) : null}
    </NavLink>
  );
}
